import React from "react";

const FilterList = ({
  items,
  activeKey,
  onSelect,
  getDisabled,
  allFilters,
}) => {
  return (
    <div className="filters-dropdown" onClick={(e) => e.stopPropagation()}>
      {items.map((item, idx) => {
        const [arabic, english] = item.menuOption.split("%");
        const disabled = getDisabled ? getDisabled(item, allFilters) : false;
        const isActive = activeKey === item.key;

        return (
          <React.Fragment key={item.key}>
            <div
              className={`filters-dropdowns-items
                          ${isActive ? "is-active" : ""}
                          ${
                            disabled ? "filters-dropdowns-items-grey-color" : ""
                          }`}
              onClick={() => !disabled && onSelect({ key: item.key })}
            >
              <span className="items-eng-text">{english}</span>
              <span className="items-arab-text" dir="rtl">
                {arabic}
              </span>
            </div>

            {idx < items.length && english !== "vertical" && (
              <div className="filters-menu-divider" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default FilterList;
